<template>
  <div id="recipient-root">
    <div id="collapser">
      <font-awesome-icon :icon="collapsed ? 'caret-square-down' : 'caret-square-up'"
                         @click="toggleCollapse">
      </font-awesome-icon>
    </div>
    <div v-if="collapsed" class="recipient-small-view" @click="toggleCollapse">
      <div>{{value.reference || 'No reference set'}}</div>
      <div>{{value.email || 'No email set'}}</div>
      <div :key="index" v-for="(person, index) in value.persons">{{person.name}}</div>
    </div>
    <div v-if="!collapsed" class="recipient-big-view">
      <div class="recipient-first">
        <vue-form>
          <vue-form-item field="reference" label="Reference:">
            <vue-input v-model="value.reference"
                       v-validate="'required'"
                       name="reference"
                       placeholder="e.g. 'George and family'"
            >
              <template slot="prefix">
                <font-awesome-icon icon="users"/>
              </template>
            </vue-input>
          </vue-form-item>
          <vue-form-item field="email" label="Email">
            <vue-input v-model="value.email"
                       v-validate="'required|email'"
                       name="email"
            >
              <template slot="prefix">
                <font-awesome-icon icon="envelope"/>
              </template>
            </vue-input>
          </vue-form-item>
        </vue-form>
      </div>

      <div class="person"
           v-for="(person, index) in value.persons"
           :key="index"
      >
        <RSVPPerson v-model="value.persons[index]"/>
        <div v-if="index == value.persons.length - 1"
             class="plus-minus">
          <vue-button type="danger" @click="remPerson" :disabled="value.persons.length <= 1">
            <font-awesome-icon icon="minus"/>
          </vue-button>
          <vue-button type="success" @click="addPerson" :disabled="value.persons.length >= 3">
            <font-awesome-icon icon="plus"/>
          </vue-button>
        </div>
      </div>
    </div>
    <div id="topRight">
      <router-link :to="{name: 'invitation', query: {payload, dev: true}}">
        <font-awesome-icon icon="angle-double-right"/>
      </router-link>
    </div>
  </div>
</template>

<script>
  import RSVPPerson from './RSVPPerson.vue'

  export default {
    name: 'Recipient',
    components: { RSVPPerson },
    props: {
      modelValue: {
        type: Object,
        default: () => ({
          persons: [{ name: 'Person 1' }],
          email: '',
          reference: '',
        }),
      },
    },
    data: () => ({
      collapsed: false,
      value: {
        persons: [],
        email: '',
        reference: '',
      },
    }),
    methods: {
      toggleCollapse() {
        this.collapsed = !this.collapsed
      },
      collapse() {
        this.collapsed = true
      },
      expand() {
        this.collapsed = false
      },
      addPerson() {
        this.value.persons.push({ name: `Person ${this.value.persons.length + 1}` })
      },
      remPerson() {
        this.value.persons.pop()
      },
    },
    model: {
      prop: 'modelValue',
      event: 'change',
    },
    computed: {
      payload() {
        return btoa(this.value.reference)
      },
    },
    watch: {
      value: {
        deep: true,
        handler() {
          this.$emit('change', this.value)
        },
      },
      modelValue() {
        this.value = this.modelValue
      },
    },
    created() {
      this.value = this.modelValue
    },
  }
</script>

<style lang="scss" scoped>
  .recipient-big-view {
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: flex-start;
    align-items: stretch;
  }

  .person, .recipient-first {
    padding: 1em;
    margin: 2em;
  }

  .person {
    display: flex;
    flex-direction: column;
    max-width: 30em;
    border: 0.5px solid grey;

    .plus-minus {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
    }

  }

  .recipient-first {
    min-width: 10em;
  }

  .recipient-small-view {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 0.5em;

    div {
      padding: 0 2em 0 2em;
      border-right: 0.5px solid #DDDDDD;
      width: 15em;
      overflow: hidden;
      text-align: center;

      &:first-child {
        border-left: 0.5px solid #DDDDDD;
      }
    }
  }

  #recipient-root {
    position: relative;
    display: flex;
    flex-direction: row;
    border-bottom: 0.5px solid #DDD;

    &:first-child {
      border-top: 0.5px solid #DDD;
    }
  }

  #collapser {
    //position: absolute;
    flex-shrink: 1;
    top: 0;
    left: 0;
  }

  #topRight {
    flex-grow: 1;
    text-align: end;
    padding-right: 0.5em;

  }

  #topRight a {
    color: inherit;
  }

</style>
